import { makeStyles, Theme } from '@material-ui/core';

export const useCopyToClipStyles = makeStyles<Theme>(theme => ({
  addressText: {
    color: '#000',
    fontSize: 15,
  },

  clipboardBtn: {
    fontSize: 20,
    border: 'none !important',
    marginLeft: theme.spacing(1),
    color: theme.palette.text.secondary,
  },

  clipboardBtnIcon: {
    fontSize: 'inherit',
    width:'14px',
    [theme.breakpoints.down(576)]: {
      width:'20px',
    },
  },

  clipboardBtnIconDone: {
    color: theme.palette.success.light,
  },
}));
